import React from "react";
import { Card, Row, Col, Badge, Stack, Container, Button } from "react-bootstrap";

export default function BioSection({style, className}) {
  const skills = [
    "Visual Design",
    "Protocol Design",
    "Game Theory", "Markov Analysis", "AI Agents",
    "AI Workflows", "AI Vision", "Ethereum (Solidity)",
    "SQL","Business Administration","Market Analysis",
    "JavaScript","React","Python","Git","CI/CD",
    "Node.js","Docker","MongoDB","Typescript"
  ];

  const pill = (t) => (
    <Badge key={t} bg="secondary" pill className="me-2 mb-2">
      {t}
    </Badge>
  );

  return (
    <Container className={className} style={style}>
      
      <div > 
        Technical Product Manager and Multimedia Artist based out of Toronto Ontario. I blend art and science.
      </div>

      {/* Contact */}

      {/* <div>
        {skills.map(pill)}
      </div> */}

    </Container>
  );
}

function SectionTitle({ children }) {
  return (
    <div className="text-uppercase text-muted mt-4 mb-2" style={{ letterSpacing: 1 }}>
      {children}
    </div>
  );
}

function ContactItem({ icon, label, href }) {
  return (
    <a
      href={href}
      className="d-flex align-items-center text-decoration-none"
      style={{ color: "var(--bs-light)" }}
    >
      <span className="me-2" aria-hidden="true" style={{ width: 20, textAlign: "center" }}>
        {icon}
      </span>
      <span>{label}</span>
    </a>
  );
}
